var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// useState
import { alertState, confirmState } from "../../../recoil/assessmentState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import EhpPagination from "../../common/pagination/EhpPagination";
import CmmConfirmPop from "../../common/popup/CmmConfirmPop";
export default function UserCommView(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [confirm, setConfirm] = useRecoilState(confirmState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { handleOpenPop } = props;
    const [userList, setUserList] = useState([]);
    const [pageInfo, setPageInfo] = useState({
        number: 0,
        size: 10,
        totalElements: 0,
        totalPages: 0,
    });
    const [search, setSearch] = useState("");
    const [userIdPk, setUserIdPk] = useState(0);
    const [banReason, setBanReason] = useState("");
    const [sortData, setSortData] = useState({
        sortField: "rownumber",
        sort: "asc",
    });
    let appPath = `page=${pageInfo.number}&size=10&sort=${sortData.sortField},${sortData.sort}`;
    if (!CUTIL.isnull(search))
        appPath = appPath + `&nickName=${search}`;
    let data = null;
    function searchList(page, selSortField, selSort) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!CUTIL.isnull(page))
                appPath = `page=${page}&size=10&sort=${CUTIL.isnull(selSortField) ? sortData.sortField : selSortField},${CUTIL.isnull(selSort) ? sortData.sort : selSort}`;
            if (!CUTIL.isnull(search))
                appPath = appPath + `&nickName=${search}`;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/users/community?${appPath}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            const ERR_URL = HTTPUTIL.resultCheck(true, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let body = data.body;
                    setUserList(body.map((item, index) => (Object.assign(Object.assign({}, item), { isSelected: false }))));
                    setPageInfo(data.data.page);
                }
            }
        });
    }
    useEffect(() => {
        searchList(0, null, null);
    }, []);
    useEffect(() => {
        handleOpenPop("pop-clear", _jsx(PauseAccountPop, { userIdPk: userIdPk, callList: () => searchList(pageInfo.number, null, null) }));
        handleOpenPop("pop-stopclear", _jsx(StopPauseAccountPop, { userIdPk: userIdPk, banReason: banReason, callList: () => searchList(pageInfo.number, null, null) }));
    }, []);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
        searchList(page, null, null);
    }
    function onChangeValue(e) {
        let value = e.target.value;
        setSearch(value);
    }
    function onClickSearch() {
        searchList(0, null, null);
    }
    function removeSearchParam() {
        setSearch("");
    }
    function searchEnter(e) {
        if (e.key == "Enter") {
            searchList(0, null, null);
        }
    }
    function pauseAccount(e, userId) {
        setUserIdPk(userId);
        CUTIL.jsopen_Popup(e);
    }
    function stopPauseAccount(e, userId, reason) {
        setUserIdPk(userId);
        setBanReason(reason);
        CUTIL.jsopen_Popup(e);
    }
    function onClickSort(e) {
        var actTag = e.target.tagName == "TH" ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = sortData.sort === "asc" ? "DESC" : "asc";
        if (selSortField !== sortData.sortField) {
            // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        setSortData({
            sortField: selSortField,
            sort: selSort,
        });
        searchList(0, selSortField, selSort);
    }
    function onClickEnabled(userId) {
        setConfirm(Object.assign(Object.assign({}, confirm), { header: "사용자 활성화", content: "사용자 인증 [이메일 인증]이 안된 사용자입니다. 사용자를 활성화하시겠습니까?", leftBtnName: "취소", rightBtnName: "활성화", rightBtnCallBack: () => __awaiter(this, void 0, void 0, function* () {
                let resEnable = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/user/${userId}/enable`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                const ERR_URL = HTTPUTIL.resultCheck(true, resEnable);
                if (ERR_URL.length > 0)
                    navigate(ERR_URL);
                if (resEnable) {
                    if (resEnable.codeNum == CONST.API_200) {
                        setAlert(Object.assign(Object.assign({}, alert), { header: "사용자 활성화", type: CONST.TYPE_NONE, divTag: "사용자가 활성화되었습니다.", callBack: () => {
                                searchList(null, null, null);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }) }));
        CUTIL.jsopen_AlertPopup(CONST.POP_CMM_CONFIRM);
    }
    // 로그인 잠김(비밀번호 연속 불일치) 해제 - 해제 시 새 비밀번호가 이메일로 전송된다.
    function onClickUnlock(userId) {
        setConfirm(Object.assign(Object.assign({}, confirm), { header: "계정 잠금 해제", content: "비밀번호를 연속으로 잘못 입력하여 잠긴 계정입니다. 잠금을 해제하시겠습니까? 해제 시 새 비밀번호가 이메일로 전송됩니다.", leftBtnName: "취소", rightBtnName: "잠금 해제", rightBtnCallBack: () => __awaiter(this, void 0, void 0, function* () {
                let res = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/auth/user/${userId}/unlock`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                const ERR_URL = HTTPUTIL.resultCheck(true, res);
                if (ERR_URL.length > 0)
                    navigate(ERR_URL);
                if (res) {
                    if (res.codeNum == CONST.API_200) {
                        setAlert(Object.assign(Object.assign({}, alert), { header: "계정 잠금 해제", type: CONST.TYPE_NONE, divTag: "계정 잠금이 해제되고 새 비밀번호가 이메일로 전송되었습니다.", callBack: () => {
                                searchList(null, null, null);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }) }));
        CUTIL.jsopen_AlertPopup(CONST.POP_CMM_CONFIRM);
    }
    function clickTr(e, index) {
        let users = [...userList];
        let list = document.querySelectorAll(".userList");
        let tr = e.target.closest("tr");
        let classLst = tr.classList;
        if (classLst.contains("selected")) {
            // tr.classList.remove("selected");
            users[index].isSelected = false;
            setUserList(users);
        }
        else {
            // list.forEach(item=>(item.classList.remove("selected")));
            users.map((item) => (item.isSelected = false));
            users[index].isSelected = true;
            setUserList(users);
            // tr.classList.add("selected");
        }
    }
    function mouseOver(e, index) {
        let users = [...userList];
        if (!users[index].isSelected) {
            let span = e.target.querySelector("span");
            span.classList.remove("txt-gray");
            let cls = e.target.closest("button").classList;
            cls.remove("bg-no");
        }
    }
    function mouseLeave(e, index, sort) {
        let users = [...userList];
        if (!users[index].isSelected) {
            let cls = e.target.closest("button").classList;
            cls.add("bg-no");
            if (sort == 1) {
                let span = e.target.querySelector("span");
                span.classList.add("txt-gray");
            }
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "SEI \uCEE4\uBBA4\uB2C8\uD2F0" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uB2C9\uB124\uC784" }) })), _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: search, onChange: onChangeValue, onKeyDown: searchEnter }), search && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: removeSearchParam }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: onClickSearch }, { children: _jsx("span", { children: "\uAC80\uC0C9" }) }))] })) })) })) })), _jsx("div", Object.assign({ className: "tbl-list userlist tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uB4F1\uB85D \uC21C,\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uD68C\uC0AC,\uC774\uB984,E-mail(ID),\uC5F0\uB77D\uCC98,\uB2F4\uB2F9 \uC0AC\uC5C5\uC7A5,\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778,\uC2B9\uC778\uC0C1\uD0DC \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "200px" } }), _jsx("col", { style: { width: "200px" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "160px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "rownumber" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "rownumber" }, { children: _jsx("span", { children: "\uB4F1\uB85D \uC21C" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC0AC\uC6A9\uC790 \uD0C0\uC785" }) })), _jsx("th", Object.assign({ scope: "col", className: "pl-16" }, { children: "\uC774\uB984" })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "nickName" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "nickName" }, { children: _jsx("span", { children: "\uB2C9\uB124\uC784" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC774\uBA54\uC77C" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC5F0\uB77D\uCC98" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC5C5\uC885" })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "banned" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "banned" }, { children: _jsx("span", { children: "\uACC4\uC815\uC0C1\uD0DC" }) }))] }) }), _jsx("tbody", { children: userList &&
                                                userList.map((item, index) => (_jsxs("tr", Object.assign({ onClick: (e) => clickTr(e, index), className: `userList ${item.isSelected ? "selected" : ""}` }, { children: [_jsx("td", { children: item.rowNumber }), _jsx("td", Object.assign({ className: item.sort != 3 ? "disabled" : "" }, { children: _jsx("span", { children: item.role }) })), _jsx("td", Object.assign({ className: item.sort != 3 ? "pl-16 disabled" : "pl-16" }, { children: _jsx("span", { children: item.userName }) })), _jsx("td", Object.assign({ className: item.sort != 3 ? "disabled" : "" }, { children: item.nickName })), _jsx("td", Object.assign({ className: item.sort != 3 ? "disabled" : "" }, { children: _jsx("p", Object.assign({ className: "" }, { children: item.userId })) })), _jsx("td", Object.assign({ className: item.sort != 3 ? "disabled" : "" }, { children: item.phoneNumber })), _jsx("td", Object.assign({ className: item.sort != 3 ? "disabled" : "" }, { children: _jsx("p", Object.assign({ className: "" }, { children: item.classification })) })), _jsx("td", { children: item.accountLocked ? (_jsxs("button", Object.assign({ type: "button", className: "btn-small-round red js-open", onClick: (e) => onClickUnlock(item.userIdPk) }, { children: [_jsx("span", Object.assign({ className: "" }, { children: "\uB85C\uADF8\uC778\uC7A0\uAE40" })), _jsx("span", Object.assign({ className: "" }, { children: "\uD574\uC81C" }))] }))) : item.sort == 1 ? (_jsx("button", Object.assign({ type: "button", className: `btn-basic js-open bg-no`, onClick: (e) => onClickEnabled(item.userIdPk) }, { children: _jsx("span", Object.assign({ className: `${item.isSelected ? "" : "txt-gray"}` }, { children: "\uBBF8\uC778\uC99D" })) }))) : item.sort == 2 ? (_jsxs("button", Object.assign({ type: "button", className: "btn-small-round red js-open", "data-pop": "pop-stopclear", onClick: (e) => stopPauseAccount(e, item.userIdPk, item.banReason) }, { children: [_jsx("span", Object.assign({ className: "" }, { children: "\uC911\uC9C0\uB428" })), _jsx("span", Object.assign({ className: "" }, { children: "\uD574\uC81C" }))] }))) : item.sort == 3 ? (_jsx("button", Object.assign({ type: "button", className: `btn-basic js-open bg-no`, "data-pop": "pop-clear", onClick: (e) => pauseAccount(e, item.userIdPk) }, { children: _jsx("span", { children: "\uACC4\uC815\uC911\uC9C0" }) }))) : ("") })] }), `userList_${index}`))) })] })) })), pageInfo.totalElements > 0 && (_jsx(EhpPagination, { componentName: "COMM_USER", pageInfo: pageInfo, handleCurPage: handleCurPage }))] }))] })), _jsx(CmmConfirmPop, {})] }));
}
function PauseAccountPop(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    let userIdPk = props.userIdPk;
    const [contents, setContents] = useState("");
    const [errMsg, setErrMsg] = useState("");
    function onChangeContents(e) {
        setErrMsg("");
        let content = e.target.value;
        setContents(content);
    }
    let data = null;
    function onClickPause() {
        return __awaiter(this, void 0, void 0, function* () {
            if (CUTIL.isnull(contents)) {
                setErrMsg("중지 신고 사유를 적어주세요.");
                return;
            }
            else if (contents.length > 20) {
                setErrMsg("신고 사유는 20자를 넘을 수 없습니다.");
                return;
            }
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${userIdPk}/isbanned`,
                appQuery: { reason: contents },
                userToken: userInfo.loginInfo.token,
            });
            const ERR_URL = HTTPUTIL.resultCheck(true, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { header: "계정중지", type: CONST.TYPE_NONE, divTag: "계정이 중지되었습니다.", callBack: () => {
                            CUTIL.jsclose_Popup("pop-clear");
                            setContents("");
                            setErrMsg("");
                            props.callList();
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function closePop() {
        CUTIL.jsclose_Popup("pop-clear");
        setContents("");
        setErrMsg("");
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-clear", className: "popup-layer js-layer hidden popup-type1 w480" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uACC4\uC815\uC911\uC9C0" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC911\uC9C0 \uC0AC\uC720" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h146", onChange: onChangeContents, value: contents }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [contents.length, " / 20"] })), errMsg && (_jsx("p", Object.assign({ id: "errortxt", style: { color: "red" } }, { children: errMsg })))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: onClickPause }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
}
function StopPauseAccountPop(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    let userIdPk = props.userIdPk;
    let reason = props.banReason;
    let data = null;
    function onClickPause() {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.jsclose_Popup("pop-stopclear");
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${userIdPk}/isbanned`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            const ERR_URL = HTTPUTIL.resultCheck(true, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { header: "계정중지해제", type: CONST.TYPE_NONE, divTag: "계정 중지가 해제되었습니다.", callBack: () => {
                            props.callList();
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function closePop() {
        CUTIL.jsclose_Popup("pop-stopclear");
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-stopclear", className: "popup-layer js-layer hidden popup-basic" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uACC4\uC815\uC911\uC9C0 \uD574\uC81C" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("p", { children: ["[", reason, "] \uC0AC\uC720\uB85C \uACC4\uC815 \uC0AC\uC6A9\uC774 \uC911\uC9C0\uB41C \uC0AC\uC6A9\uC790\uC785\uB2C8\uB2E4. \uACC4\uC815\uC911\uC9C0\uB97C \uD574\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"] }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: onClickPause }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
}
